import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  CustomFieldEntityState,
  useCustomFieldsQuery,
} from "@common/utils/graphql";
import { CustomFieldInput } from "./CustomFieldInput";
import { UseFormReturn } from "react-hook-form";
import { cn } from "@/utils/utils";
import { useMemo } from "react";
import { getCustomFormFieldName, orderCustomFields } from "./utils";

type Props = {
  form: UseFormReturn<any>;
  loading: boolean;
};

export const CustomFormFields = ({ form, loading }: Props) => {
  const { data: customFieldsData } = useCustomFieldsQuery({
    fetchPolicy: "cache-only", // The nextwork fetch happens upstream by useCustomFieldsFormConfig
  });

  const customFields = useMemo(() => {
    return customFieldsData?.visibleCustomFields.__typename ===
      "QueryVisibleCustomFieldsSuccess"
      ? orderCustomFields(
          customFieldsData.visibleCustomFields.data.customFields,
        )
      : [];
  }, [customFieldsData]);

  return customFields.map((customField) => (
    <FormField
      key={`custom-form-field--field-${customField.id}`}
      control={form.control}
      disabled={loading}
      name={getCustomFormFieldName(customField)}
      render={({ field }) => (
        <FormItem>
          <FormLabel
            className={cn("flex", {
              "justify-between":
                customField.state === CustomFieldEntityState.Optional,
            })}
          >
            <span>{customField.name}</span>
            {customField.state === CustomFieldEntityState.Optional && (
              <span>Optional</span>
            )}
          </FormLabel>
          <FormControl>
            <CustomFieldInput customField={customField} {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  ));
};
